export const SAVE_USER_INFO = "SAVE_USER_INFO";
export const SAVE_SETTING_DATA = "SAVE_SETTING_DATA";